"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Option;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _styles = require("@material-ui/core/styles");
var _react = _interopRequireWildcard(require("react"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _reactSelect = require("react-select");
var _Checkbox = _interopRequireDefault(require("../../Checkbox"));
var _MenuItem = _interopRequireDefault(require("../../MenuItem"));
var _Tooltip = _interopRequireDefault(require("../../Tooltip"));
var _util = require("./util");
var _excluded = ["onClick"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    accentColor: {
      color: theme.palette.primary.main
    },
    matchedText: {
      fontWeight: 'bold'
    },
    option: {
      fontSize: 13,
      lineHeight: '20px'
    },
    standardText: {
      fontWeight: 400
    }
  };
});
var RenderWithTooltip = function RenderWithTooltip(_ref) {
  var _optionRef$current;
  var children = _ref.children;
  var hasOverflowingChildren = false;
  var optionRef = children.ref;
  if (optionRef !== null && optionRef !== void 0 && (_optionRef$current = optionRef.current) !== null && _optionRef$current !== void 0 && _optionRef$current.offsetParent) {
    // added 20 padding due to a bug related to https://jira.proofpoint.com/jira/browse/DSP-794
    hasOverflowingChildren = optionRef.current.offsetWidth + 20 > optionRef.current.offsetParent.clientWidth;
  }
  if (hasOverflowingChildren) {
    return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      title: children
    }, children);
  }
  return children;
};
var _ref2 = /*#__PURE__*/_react["default"].createElement("span", null, "Create");
function Option(props) {
  var children = props.children,
    _props$data = props.data,
    isNew = _props$data.__isNew__,
    inlineStyle = _props$data.inlineStyle,
    FormatOptionLabelComponent = _props$data.FormatOptionLabelComponent,
    description = _props$data.description,
    fontSize = _props$data.fontSize,
    color = _props$data.color,
    _props$innerProps = props.innerProps,
    innerProps = _props$innerProps === void 0 ? {} : _props$innerProps,
    innerRef = props.innerRef,
    isSelected = props.isSelected,
    isDisabled = props.isDisabled,
    isMulti = props.isMulti,
    selectProps = props.selectProps,
    value = props.value;
  var classes = useStyles();
  var optionRef = (0, _react.useRef)(null);

  // strip out onClick being passed down in the Select
  // select Option component is internally handling this
  // this causes the handler to fire twice
  var onClick = innerProps.onClick,
    restInnerProps = (0, _objectWithoutProperties2["default"])(innerProps, _excluded);
  var createNewOption = function createNewOption(optionText) {
    var inputText = optionText.slice(optionText.indexOf('"') + 1, -1);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _ref2, /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.accentColor
    }, " \"".concat(inputText, "\"")));
  };
  var getCorrectSelectOptions = function getCorrectSelectOptions() {
    var optionText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var searchInputValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (isNew) {
      return createNewOption(optionText);
    }
    if (FormatOptionLabelComponent) {
      var optionLabelText = (0, _util.getHighlightedText)(optionText, searchInputValue, classes);
      var optionDescriptionText = (0, _util.getHighlightedText)(description, searchInputValue, classes);
      return /*#__PURE__*/_react["default"].createElement(FormatOptionLabelComponent, {
        color: color,
        description: optionDescriptionText,
        fontSize: fontSize,
        label: optionLabelText
      });
    }
    return (0, _util.getHighlightedText)(optionText, searchInputValue, classes);
  };
  var customInlineStyle = !(0, _isEmpty["default"])(inlineStyle) ? inlineStyle : {};

  //  search by value if children is not a string
  var childrenText = typeof children === 'string' ? children : value;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, (0, _extends2["default"])({}, props, {
    automationid: "".concat(selectProps.automationid, "-menu-item"),
    innerProps: _objectSpread({}, innerProps, {
      'data-metrics': selectProps.dataMetrics.option
    })
  }), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({
    style: customInlineStyle,
    classes: {
      root: selectProps.classes.option
    },
    component: "div",
    disabled: isDisabled,
    disableGutters: true,
    ref: innerRef
  }, restInnerProps), isMulti && /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    checked: isSelected,
    className: selectProps.classes.multiSelectCheckbox
  }), /*#__PURE__*/_react["default"].createElement(RenderWithTooltip, null, /*#__PURE__*/_react["default"].createElement("span", {
    ref: optionRef
  }, selectProps.inputValue ? getCorrectSelectOptions(childrenText, selectProps.inputValue) : children))));
}